// extracted by mini-css-extract-plugin
module.exports = {"pane":"GendersPanel-pane-a379"};